<template>
  <el-dialog
    v-model="dialogTableVisible"
    header-class="headerCla"
    :title="ruleForm.categoryId ? proxy.$t('material.newNmae') : proxy.$t('material.newWork')"
    width="500"
    :close-on-click-modal="true"
    @close="close(ruleFormRef)"
  >
    <el-form
      ref="ruleFormRef"
      style="max-width: 600px"
      :model="ruleForm"
      status-icon
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm"
      label-position="top"
    >
      <el-form-item
        label=""
        prop="name"
        style="margin-top: 20px"
      >
        <el-input
          v-model="ruleForm.name"
          :placeholder="proxy.$t('Shared.pleaseEnter')"
          maxlength="30"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="close(ruleFormRef)">
          {{ proxy.$t('Shared.Cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="submitForm(ruleFormRef)"
        >
          {{ proxy.$t('Shared.Confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts" setup>
const { proxy } = getCurrentInstance();
import { reactive, ref } from 'vue';
import type { FormInstance } from 'element-plus';
import { editCategoryApi, addCategoryApi } from '@/api/brand/material';
const emits = defineEmits(['Update']);
const ruleFormRef = ref<FormInstance>();
const dialogTableVisible = ref(false);
const ruleForm = reactive({
  categoryId: '',
  name: '',
  parentId: '-1',
});
const rules = reactive({
  name: [{ required: true, message: proxy.$t('Shared.pleaseEnter') + proxy.$t('material.work'), trigger: 'blur' }],
});
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (ruleForm.categoryId) {
        editCategoryApi(ruleForm).then(() => {
          ElMessage({
            message: proxy.$t('Shared.editMessage'),
            type: 'success',
          });
          close(ruleFormRef.value);
          emits('Update');
        });
      } else {
        addCategoryApi(ruleForm).then(() => {
          ElMessage({
            message: proxy.$t('Shared.success'),
            type: 'success',
          });
          close(ruleFormRef.value);
          emits('Update');
        });
      }
    } else {
      console.log('error submit!', fields);
    }
  });
};
// 重值
const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
};
// 关闭
function close(formEl: FormInstance | undefined) {
  resetForm(formEl);
  dialogTableVisible.value = false;
}
// 打开
const visibleFn = (type, data) => {
  dialogTableVisible.value = true;
  if (type == 'add') {
    // 新增
    ruleForm.parentId = data.id;
    ruleForm.name = '';
    ruleForm.categoryId = '';
  } else {
    ruleForm.parentId = data.parentId;
    ruleForm.name = data.label;
    ruleForm.categoryId = data.id;
  }
};

defineExpose({
  visibleFn,
});
</script>
<style lang="scss" scoped>
.headerCla {
  border-bottom: #fff solid 1px !important;

  .el-dialog__title {
    font-weight: 700;
  }
}
</style>
